import { TFunction } from "i18next";

import { SystemDropdownCategory, SystemDropdownParameter } from "@/api";
import { SystemDropdownParameterValue } from "@/common/constants/systemDropdownParameterValues";
import { assertUnreachable } from "@/common/helper/commonHelper";

export function getSystemDropdownCategoryLabel(category: SystemDropdownCategory, t: TFunction): string {
  switch (category) {
    case SystemDropdownCategory.AppointmentPurpose:
      return t("settings.systemDropdowns.categories.appointmentPurpose");
    case SystemDropdownCategory.AttendancePurpose:
      return t("settings.systemDropdowns.categories.attendancePurpose");
    case SystemDropdownCategory.CaseNoteType:
      return t("settings.systemDropdowns.categories.caseNoteType");
    case SystemDropdownCategory.ClientStatus:
      return t("settings.systemDropdowns.categories.clientStatus");
    case SystemDropdownCategory.ClaimBalanceEntryType:
      return t("settings.systemDropdowns.categories.claimBalanceEntryType");
    case SystemDropdownCategory.SrvCourseEntryType:
      return t("settings.systemDropdowns.categories.srvCourseEntryType");
    case SystemDropdownCategory.IncomeType:
      return t("settings.systemDropdowns.categories.incomeType");
    default:
      return assertUnreachable(category);
  }
}

export function getSystemDropdownParameterLabel(parameter: SystemDropdownParameter, t: TFunction): string {
  switch (parameter) {
    case SystemDropdownParameter.Overbookable:
      return t("settings.systemDropdowns.parameters.overbookable");
    case SystemDropdownParameter.AttendanceType:
      return t("settings.systemDropdowns.parameters.attendanceType");
    case SystemDropdownParameter.Deletable:
      return t("settings.systemDropdowns.parameters.deletable");
    case SystemDropdownParameter.Editable:
      return t("settings.systemDropdowns.parameters.editable");
    case SystemDropdownParameter.SrvRegistered:
      return t("settings.systemDropdowns.parameters.srvRegistered");
    case SystemDropdownParameter.Projected:
      return t("settings.systemDropdowns.parameters.projected");
    case SystemDropdownParameter.IncomeTreatment:
      return t("settings.systemDropdowns.parameters.incomeTreatment");
    case SystemDropdownParameter.AvailableInExchange:
      return t("settings.systemDropdowns.parameters.availableInExchange");
    case SystemDropdownParameter.Conversation:
      return t("settings.systemDropdowns.parameters.conversation");
    default:
      return assertUnreachable(parameter);
  }
}

/**
 * Parameter values are persisted as opaque strings so one store can carry every parameter kind.
 * Boolean parameters render as Ja/Nein, single-select parameters as their own localized option.
 */
export function getSystemDropdownParameterValueLabel(value: string, t: TFunction): string {
  switch (value) {
    case SystemDropdownParameterValue.True:
      return t("common.yes");
    case SystemDropdownParameterValue.False:
      return t("common.no");
    case SystemDropdownParameterValue.AttendancePresent:
      return t("settings.systemDropdowns.parameterValues.present");
    case SystemDropdownParameterValue.AttendanceAbsent:
      return t("settings.systemDropdowns.parameterValues.absent");
    case SystemDropdownParameterValue.IncomeStandard:
      return t("settings.systemDropdowns.parameterValues.incomeStandard");
    case SystemDropdownParameterValue.IncomeNonSeizable:
      return t("settings.systemDropdowns.parameterValues.incomeNonSeizable");
    case SystemDropdownParameterValue.IncomeDailyRate:
      return t("settings.systemDropdowns.parameterValues.incomeDailyRate");
    case SystemDropdownParameterValue.IncomeSpecialPaymentsExpected:
      return t("settings.systemDropdowns.parameterValues.incomeSpecialPaymentsExpected");
    default:
      return value;
  }
}
